// src/components/store/sections/newsletter/NewsletterV28MinimalinlineSunsetAmber.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV28MinimalinlineSunsetAmber(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={28}
      archKey="minimal_inline"
      archLabel="Minimalist Inline Strip"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
